import { Component } from "@angular/core";
import { routerTransition } from "../../router.animations";

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class Error404Component {
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/features/error404/error404.component.ts